import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '@/app/hooks'
import { ModalWrapper } from '@/components/atoms/modal-wrapper'
import { useBreakPoint } from '@/hooks/use-break-point'
import { css } from '@emotion/react'

interface SpaceReservationCancelCompleteModalProps {
  isOpen: boolean
  onClose: () => void
}

export const SpaceReservationCancelCompleteModal: React.FC<SpaceReservationCancelCompleteModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation()
  const { isPc } = useBreakPoint()
  const design = useAppSelector(state => state.design)

  return (
    <ModalWrapper
      isOpen={isOpen}
      modalStyle={{
        height: 'auto',
        maxHeight: 150,
        padding: '20px 0 16px 0',
        width: isPc ? '343px' : 'auto',
        boxShadow: '0px 2px 10px #00000029',
        borderRadius: '6px',
      }}
      onClose={onClose}
    >
      <div css={contentStyle}>
        <h2 css={modalTitle} style={{ color: design?.text.textColor }}>
          {t('Reservation cancelled successfully')}
        </h2>
        <div css={buttonWrapperStyle}>
          <button type="button" css={[buttonBase, okButtonStyle]} onClick={onClose}>
            {t('Close')}
          </button>
        </div>
      </div>
    </ModalWrapper>
  )
}

const contentStyle = css({
  textAlign: 'center',
  paddingInline: '24px',
})

const modalTitle = css({
  margin: '0 0 1.5rem',
  fontSize: '18px',
  lineHeight: '28px',
  fontWeight: 'bold',
  letterSpacing: '0.6px',
})

const buttonWrapperStyle = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
})

const buttonBase = css({
  width: '148px',
  height: '48px',
  padding: 0,
  fontSize: '16px',
  lineHeight: '32px',
  fontWeight: 500,
  letterSpacing: '0.8px',
  borderRadius: '6px',
  cursor: 'pointer',
  border: 'none',
})

const okButtonStyle = css({
  background: '#A59785 0% 0% no-repeat padding-box',
  color: '#FFFFFF',
})
